import { displayMessage } from '../../../services/helper';

export default (enums, isDentist = false) => {
    const allGridColumns = [
        {
            field: 'dentist',
            headerName: displayMessage('DENTIST'),
            width: 200,
            valueGetter: function (params) {
                return `${params.row?.Dentist?.first_name || ''} ${params.row?.Dentist?.last_name || ''}`
            }
        },
        {
            field: 'fullName',
            headerName: displayMessage('PATIENT'),
            width: 200,
            valueGetter: function (params) {
                return `${params.row.first_name || ''} ${params.row.last_name || ''}`
            }
        },
        {
            field: 'mangos',
            headerName: displayMessage('MANGOS'),
            width: 100,
            valueGetter: function (params) {
                return params.row.mangos.toFixed(2)
            }
        },
        {
            field: 'cpf',
            headerName: displayMessage('CPF_PATIENT'),
            width: 200
        },
        {
            field: 'identificator_patient',
            headerName: displayMessage('IDENTIFIER_PATIENT'),
            width: 200
        },
        {
            field: 'fullNameResponsible',
            headerName: displayMessage('RESPONSIBLE'),
            width: 200,
            valueGetter: function (params) {
                return `${params.row.first_name_responsible || ''} ${params.row.last_name_responsible || ''}`
            }
        },
        {
            field: 'cpf_responsible',
            headerName: displayMessage('RESPONSIBLE_CPF'),
            width: 200
        },
        {
            field: 'cell_phone_responsible',
            headerName: displayMessage('RESPONSIBLE_PHONE'),
            width: 200
        },
        {
            field: 'email',
            headerName: displayMessage('EMAIL'),
            width: 200,
            valueGetter: function (params) {
                return `${params.row.email ?? displayMessage('NOT_INFORMED')}`
            }
        },
        {
            field: 'birth_date',
            type: 'date',
            headerName: displayMessage('BIRTHDAY'),
            width: 220,
            headerClassName: 'grid-headers-bold',
            valueFormatter: (params) => {
                if (!params?.value) { return params?.value }
                const dateString = params.value
                const inputDate = new Date(dateString);
                const outputString = `${inputDate.getDate().toString().padStart(2, '0')}/${(inputDate.getMonth() + 1).toString().padStart(2, '0')}/${inputDate.getFullYear()}`;

                return outputString
            }
        },
        {
            field: 'gender',
            headerName: displayMessage('GENDER'),
            width: 200,
            valueGetter: function (params) {
                return `${params.row.gender_formatted.description ?? displayMessage('NOT_INFORMED')}`
            }
        },
        {
            field: 'last_offline_sync',
            type: 'date',
            headerName: displayMessage('LAST_SYNC_DATE'), 
            width: 220, 
            headerClassName: 'grid-headers-bold',
            valueFormatter: (params) => {
                if (!params?.value) { return params?.value }
                const dateString = params.value
                const inputDate = new Date(dateString);
                const outputString = `${inputDate.getDate().toString().padStart(2, '0')}/${(inputDate.getMonth() + 1).toString().padStart(2, '0')}/${inputDate.getFullYear()}`;

                return outputString
            }
        }
    ]
    if (isDentist) {
        return allGridColumns.filter(column => column.field !== 'dentist')
    }
    return (
        allGridColumns
    )
}
